module.exports = __webpack_public_path__ + "static/img/gpt76.9f7dc876.png";